import ClientTemplate from "@/pages/ClientTemplate";
import Main from "@/pages/Main";
import Company from "@/pages/Company";
import SmartGate from "@/pages/SmartGate";
import SmartGate_1 from "@/pages/SmartGate_1";
import SmartGate_2 from "@/pages/SmartGate_2";
import Gallery from "@/pages/Gallery";
import System from "@/pages/System";
import Eshop from "@/pages/Eshop";

export default [
  {
    path     : "/",
    name     : "index",
    meta     : { authRequired: false },
    redirect : "/main",
    component: ClientTemplate,
    children : [
      {
        path     : "main",
        name     : "Main",
        component: Main
      },
      {
        path     : "company",
        name     : "Company",
        component: Company
      },
      {
        path     : "smartGate",
        name     : "SmartGate",
        component: SmartGate,
        children : [
          {
            path     : "",
            component: SmartGate_1
          },
          {
            path     : "2",
            component: SmartGate_2
          }
        ]
      },
      {
        path     : "gallery",
        name     : "Gallery",
        component: Gallery,
        props    : true
      },
      {
        path     : "system",
        name     : "System",
        component: System
      },
      {
        path     : "eshop",
        name     : "Eshop",
        component: Eshop
      }
    ]
  }
];
